import React, { useState, useEffect, useRef } from "react";
import { useLocation, useNavigate, Link } from "react-router-dom";
import "../../../css/dashboard.css"
import axios from 'axios';
import CommonTable from "../../component/table_list/common_table";
import CommonTableRow from "../../component/table_list/common_tablerow";
import CommonTableColumn from "../../component/table_list/common_tablecolumn";
import Pagination from "react-js-pagination";
import styled from "styled-components"
import Menu from "../../component/main_menu"
import { formatDate } from "../../utils/format_date"
import { useAuthContext } from '../../common/ProtectedLayout';
import { getNoticeEventRequestErrorMessage } from '../notice_event_request';
import NoticeEventImageField, { buildNoticeEventFormData } from '../notice_event_image_field';

function ManagerEvent(props) {

    const location = useLocation();
    const navigate = useNavigate();
    const [isValidAccess, setIsValidAccess] = useState(false);

    const [eventInfo, setEventInfo] = useState([]);
    const [imageFile, setImageFile] = useState(null);
    const [eventList, setEventList] = useState([]);
    const [page, setPage] = useState(1);
    const items = 10;
    const hadlePageChange = (page) => { setPage(page) };
    const [reserveCount, setReserveCount] = useState(0);
    const auth = useAuthContext();

    const [eventToDelete, setEventToDelete] = useState(null);
    const [isSubmitting, setIsSubmitting] = useState(false);
    const deleteDialogRef = useRef();
    const modalCorrective = useRef();

    const loadData = async () => {
        try {
            const getPage = (page - 1) * 10;
            const [listResult, countResult] = await Promise.all([
                axios.get(`/EventRegist/${getPage}?division=1`),
                axios.get('/EventRegistCount?division=1')
            ]);
            setEventList(listResult.data.message);
            setReserveCount(countResult.data.message);
        } catch (error) {
            console.error('Error fetching manager event data:', error.message);
        }
    };

    useEffect(() => {
        loadData();
    }, [page])

    useEffect(() => {
        setIsValidAccess(true);
        loadData();
    }, [location.state, navigate]);

    if (!isValidAccess) {
        return null;
    }

    const startCorrective = () => {
        setEventInfo({ title: '', content: '' });
        setImageFile(null);
        modalCorrective.current.showModal();
    }
    const openDeleteDialog = (event) => {
        setEventToDelete(event);
        deleteDialogRef.current.showModal();
    };
    const confirmDeleteEvent = async () => {
        try {
            const result = await axios.delete(`/EventRegist/${eventToDelete.idx}`);
            alert(result.data.message);
            loadData();
            deleteDialogRef.current.close();
        } catch (error) {
            console.error('Error deleting driver event:', error.message);
        }
    };


    const postEventInfo = async () => {
        if (isSubmitting) return;
        if (!eventInfo.title?.trim()) {
            alert('제목을 입력해주세요');
            return;
        }
        if (!eventInfo.content?.trim()) {
            alert('이벤트 내용을 입력해주세요');
            return;
        }
        const requestData = buildNoticeEventFormData({
            title: eventInfo.title,
            content: eventInfo.content,
            id: auth.loginId,
            division: 1,
            imageFile
        });
        setIsSubmitting(true);
        try {
            const put_result = await axios.post(`/EventRegist`, requestData);
            if (put_result.data.success === true) {
                alert('등록이 완료되었습니다');
                modalCorrective.current.close();
            } else {
                alert(put_result.data.message || '매니저 이벤트 등록에 실패했습니다.');
            }
            await loadData();
        } catch (error) {
            console.error('Error :', error.message);
            alert(getNoticeEventRequestErrorMessage(error, '매니저 이벤트 등록에 실패했습니다. 잠시 후 다시 시도해주세요.'));
        } finally {
            setIsSubmitting(false);
        }
    };


    const ChangeTitle = (e) => {
        setEventInfo({ ...eventInfo, title: e.target.value });
    }
    const ChangeContent = (e) => {
        setEventInfo({ ...eventInfo, content: e.target.value });
    }

    return (
        <div className="dashboard-container">
            <div className="content-container">
                <ListContainer>
                    <div style={{ marginTop: '50px' }}>
                        <CommonTable headerTitle={['No', '제목', '작성자', '작성일자']} columnWidths={['10%', '50%', '15%', '15%', '10%']}>
                            {
                                eventList.map((reserve, index) => {
                                    return (
                                        <CommonTableRow key={index} idx={reserve.idx} beforePage={'/manager-events'} kind={'manager_event'}>
                                            <CommonTableColumn>{reserveCount - ((page - 1) * 10) - index}</CommonTableColumn>
                                            <CommonTableColumn>{reserve.title}</CommonTableColumn>
                                            <CommonTableColumn>{reserve.id}</CommonTableColumn>
                                            <CommonTableColumn>{formatDate(reserve.regist_date)}</CommonTableColumn>
                                            <CommonTableColumn>
                                                <div className="red">
                                                    <button
                                                        style={{
                                                            padding: '6px 12px',
                                                            fontSize: '13px',
                                                            backgroundColor: 'white',
                                                            color: '#dc3545',
                                                            border: '1px solid #dc3545',
                                                            borderRadius: '4px',
                                                            cursor: 'pointer',
                                                            whiteSpace: 'nowrap'
                                                        }}
                                                        onClick={(event) => {
                                                            event.stopPropagation();
                                                            openDeleteDialog(reserve);
                                                        }}
                                                    >
                                                        삭제
                                                    </button>
                                                </div>
                                            </CommonTableColumn>
                                        </CommonTableRow>
                                    )
                                })
                            }
                        </CommonTable>
                    </div>

                    <ButtonContainer>
                        <PrimaryButton onClick={startCorrective}>이벤트등록</PrimaryButton>
                    </ButtonContainer>

                    <PaginationBox>
                        <Pagination
                            activePage={page}
                            itemsCountPerPage={items}
                            totalItemsCount={reserveCount}
                            pageRangeDisplayed={10}
                            onChange={hadlePageChange}>
                        </Pagination>
                    </PaginationBox>
                </ListContainer>
            </div>

            {/* 이벤트 등록 모달 */}
            <StyledDialog ref={modalCorrective} style={{ width: '600px' }}>
                <DialogHeader>
                    <h3>매니저 이벤트 등록</h3>
                    <CloseButton onClick={() => modalCorrective.current.close()}>&times;</CloseButton>
                </DialogHeader>
                <DialogContent>
                    <InputGroup>
                        <Label>제목</Label>
                        <StyledInput
                            value={eventInfo.title || ''}
                            onChange={ChangeTitle}
                            placeholder="제목을 입력하세요"
                        />
                    </InputGroup>
                    <InputGroup>
                        <Label>내용 (1000자 이내)</Label>
                        <StyledTextArea
                            value={eventInfo.content || ''}
                            onChange={ChangeContent}
                            placeholder="내용을 입력하세요"
                        />
                    </InputGroup>
                    <NoticeEventImageField
                        imageFile={imageFile}
                        onChange={({ imageFile: nextImage }) => setImageFile(nextImage)}
                    />
                </DialogContent>
                <DialogActions>
                    <OutlineButton onClick={() => modalCorrective.current.close()}>취소</OutlineButton>
                    <PrimaryButton onClick={postEventInfo} disabled={isSubmitting}>
                        {isSubmitting ? '등록 중...' : '등록'}
                    </PrimaryButton>
                </DialogActions>
            </StyledDialog>

            {/* 삭제 확인 모달 */}
            <StyledDialog ref={deleteDialogRef} style={{ width: '400px' }}>
                <DialogHeader>
                    <h3>매니저 이벤트 삭제</h3>
                </DialogHeader>
                <DialogContent style={{ textAlign: 'center', minHeight: '100px', justifyContent: 'center' }}>
                    {eventToDelete && (
                        <div>
                            <p style={{ fontWeight: 'bold', marginBottom: '10px', fontSize: '25px' }}>
                                {eventToDelete.title} (ID: {eventToDelete.id})
                            </p>
                            <p style={{ color: '#666', fontSize: '20px' }}>
                                등록된 매니저 이벤트를 삭제하시겠습니까?
                            </p>
                        </div>
                    )}
                </DialogContent>
                <DialogActions style={{ justifyContent: 'center' }}>
                    <OutlineButton onClick={() => deleteDialogRef.current.close()}>취소</OutlineButton>
                    <DangerButton onClick={confirmDeleteEvent}>확인</DangerButton>
                </DialogActions>
            </StyledDialog>
        </div >
    );
}

const BaseButton = styled.button`
    padding: 8px 18px; 
    border-radius: 8px; 
    font-weight: 600;
    cursor: pointer; 
    transition: all 0.2s; 
    border: none; 
    font-size: 0.9rem;
    &:disabled {
        cursor: not-allowed;
        opacity: 0.65;
    }
`;

const PrimaryButton = styled(BaseButton)`
    background-color: #007bff;
    color: white;
    &:hover { background-color: #0056b3; }
`;

const DangerButton = styled(BaseButton)`
    background-color: #d32f2f; 
    color: white;
    &:hover { background-color: #b71c1c; }
`;

const OutlineButton = styled(BaseButton)`
    background-color: white; 
    border: 1px solid #ccc; 
    color: #555;
    &:hover { background-color: #f9f9f9; border-color: #bbb; }
`;

const StyledDialog = styled.dialog`
    border: none; 
    border-radius: 16px; 
    padding: 0;
    box-shadow: 0 10px 40px rgba(0,0,0,0.25);
    &::backdrop { background: rgba(0, 0, 0, 0.6); }
`;

const DialogHeader = styled.div`
    padding: 16px 20px; 
    border-bottom: 1px solid #eee;
    display: flex; 
    justify-content: space-between; 
    align-items: center;
    h3 { margin: 0; font-size: 1.2rem; font-weight: 700; }
`;

const DialogContent = styled.div`
    padding: 24px; 
    background: #fff; 
    max-height: 80vh; 
    overflow-y: auto;
    display: flex; 
    flex-direction: column;
`;

const DialogActions = styled.div`
    padding: 16px 20px; 
    border-top: 1px solid #eee;
    display: flex; 
    justify-content: flex-end; 
    gap: 10px;
`;

const CloseButton = styled.button`
    background: none; 
    border: none; 
    font-size: 1.8rem; 
    cursor: pointer; 
    color: #999; 
    line-height: 1;
    &:hover { color: #333; }
`;

const PaginationBox = styled.div`
  .pagination { display: flex; justify-content: center; margin-top: 15px;}
  ul { list-style: none; padding: 0; }
  ul.pagination li {
    display: inline-block;
    width: 30px;
    height: 30px;
    border: 1px solid #e2e2e2;
    display: flex;
    justify-content: center;
    align-items: center;
    font-size: 1rem; 
    
  }
  ul.pagination li:first-child{ border-radius: 5px 0 0 5px; }
  ul.pagination li:last-child{ border-radius: 0 5px 5px 0; }
  ul.pagination li a { text-decoration: none; color: #337ab7; font-size: 1rem; }
  ul.pagination li.active a { color: white; }
  ul.pagination li.active { background-color: #337ab7; }
  ul.pagination li a:hover,
  ul.pagination li a.active { color: blue; }
`

const ButtonContainer = styled.div`
    display: flex;
    justify-content: flex-end;
    margin-top: 1rem;
    gap: 10px;
    width: 90%;
    margin-left: auto;
    margin-right: auto;
`;

const ListContainer = styled.div`
    width: 70%;
    margin: 0 auto;
`;

const InputGroup = styled.div`
    margin-bottom: 1.5rem;
`;

const Label = styled.label`
    display: block;
    margin-bottom: 0.5rem;
    color: #555;
    font-weight: 500;
`;

const StyledInput = styled.input`
    width: 100%;
    padding: 0.75rem;
    border: 1px solid #ddd;
    border-radius: 6px;
    font-size: 1rem;
    box-sizing: border-box;

    &:focus {
        outline: none;
        border-color: #007bff;
        box-shadow: 0 0 0 2px rgba(0, 123, 255, 0.1);
    }
`;

const StyledTextArea = styled.textarea`
    width: 100%;
    padding: 0.75rem;
    border: 1px solid #ddd;
    border-radius: 6px;
    font-size: 1rem;
    min-height: 200px;
    resize: vertical;
    box-sizing: border-box;
    word-break: break-word;
    overflow-wrap: break-word;

    &:focus {
        outline: none;
        border-color: #007bff;
        box-shadow: 0 0 0 2px rgba(0, 123, 255, 0.1);
    }
`;

export default ManagerEvent;
